import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/director/certificates",
  },
  actions: {
    list({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/list?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getTypes({ dispatch, state, rootState }, options) {
      return dispatch("FETCH", {
        url: `${state.path}/types?${serialize(options)}`,
        method: "GET",
        data: {},
      });
    },
    create({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", {
        url: `${state.path}/create`,
        method: "POST",
        data,
      });
    },
    update({ dispatch, state, rootState }, { id, data }) {
      return dispatch("FETCH", {
        url: `${state.path}/update/${id}`,
        method: "PUT",
        data,
      });
    },
    updateStatus({ dispatch, state, rootState }, { id, status }) {
      return dispatch("FETCH", {
        url: `${state.path}/update-status/${id}`,
        method: "PUT",
        data: { status },
      });
    },
    setTeacherMotivation({ dispatch, state, rootState }, { id, motivation }) {
      return dispatch("FETCH", {
        url: `${state.path}/set-teacher-motivation/${id}`,
        method: "PUT",
        data: { motivation },
      });
    },
  },
};
